<div class="provider-item" [class]="status">
  <div class="item-wrap" layout layout-space-between layout-align-items-center>
    <div class="item-content" layout layout-align-items-center>
      <div class="logo-wrap">
        <ng-container *ngTemplateOutlet="avatar"></ng-container>
      </div>

      <div class="text-wrap" layout layout-vertical>
        <rt-heading *ngIf="header; else headerTpl">{{ header }}</rt-heading>
        <span *ngIf="description; else descriptionTpl" class="description">{{ description }}</span>
      </div>
    </div>
    <div class="item-actions" layout>
      <ng-content></ng-content>
    </div>
  </div>
</div>

<ng-template #avatar>
  <rt-avatar
    [type]="initials ? 'initials' : 'icon'"
    [size]="iconSize"
    [shape]="'square'"
    [iconName]="icon"
    [isIconBgTransparent]="true"
    [isColorized]="!!initials"
    [initials]="initials"
    iconColor="colorIconDefault"
  >
  </rt-avatar>
</ng-template>
